import {environment} from "environments";

class GroupsController {
  constructor(GroupsService, ProductsService, toastr, ngDialog, Services) {
    Object.assign(this, {
      GroupsService,
      ProductsService,
      Services,
      toastr,
      ngDialog,
      editing: false,
      groups: [],
      products: [],
      searchQuery: "",
      categoriesList: [],
      selectedCategory: {},
      productGroupForEdit: {},
      childrenProducts: [],
      deleteProduct: {},
      BOD_2622: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV)
    });

    this.getProductGroups();
    this.getCategories();
  }

  getProductGroups() {
    this.GroupsService.getProductGroupsAll()
      .then(({ data }) => {
        this.groups = data;

        this.groups.sort((a, b) => a.service_code.localeCompare(b.service_code) || a.position - b.position);
      })
      .catch((err) => {
        if (err && err.data && err.data.error_message) this.toastr.error(err.data.error_message);
      });
  }

  getCategories() {
    this.GroupsService.getCategories()
      .then(({ data }) => {
        data.sort((a, b) => a.name - b.name);

        data.forEach((service) => {
          if (service.children && service.children.length) {
            service.children.forEach((child) => {
              child.code_name = `${child.code} - ${child.name}`;
              if (child.product_groups_enabled) this.categoriesList.push(child);
            });
          } else {
            service.code_name = `${service.code} - ${service.name}`;
            if (service.product_groups_enabled)
              this.categoriesList.push(service);
          }
        });

        this.categoriesList = this.categoriesList.map((item) => {
          return { ...item, service_code: item.code };
        });

        this.categoriesList.unshift({
          code_name: "Please select a service",
          service_code: "",
        });
        this.selectedCategory = this.categoriesList[0];
      })
      .catch((err) => {
        this.toastr.error(`Error getting services: ${JSON.stringify(err)}`);
      });
  }

  resetFilters() {
    this.searchQuery = "";
    this.selectedCategory = this.categoriesList[0];
    this.getProductGroups();
  }

  createNewGroup() {
    const config = {
      template: "app/components/modals/new-group.tpl.html",
      data: {
        title: "New Product Group",
        group: { selection1_label: "Dosage", selection2_label: "Quantity" }
      },
    };

    this.ngDialog.openConfirm(config)
      .then((data) => {

        if (data.position && isNaN(data.position)) {

          this.toastr.warning(`Value in position is not a number`);

        } else {

          let group = data;
          // const group = { ...data, position: parseInt(data.position) };
          if (group.position) group.position = parseInt(group.position);

          this.GroupsService.createProductGroup(group)
            .then(() => {
              this.toastr.success(`Product group has been created`);
              this.getProductGroups();
            })
            .catch((err) => {
              this.toastr.error(`Error creating group: ${JSON.stringify(err)}`);
            });
        }
      });
  }

  getProductGroupDetails(productGroup) {
    this.GroupsService.getProductGroup(productGroup.code)
      .then(({ data }) => {
        this.productGroupForEdit = data;
        this.getProducts(productGroup.service_code);
      })
      .catch((err) => {
        this.toastr.error(`Error getting group details: ${JSON.stringify(err)}`);
      });
  }

  getProducts(service_code) {
    this.ProductsService.getProductsByCode(service_code)
      .then(({ data }) => {

        if (data && data.length) {

          // this.products = data.filter((product) => !product.product_group_id || (product.product_group_id !== this.productGroupForEdit.id));

          this.products = data.filter((product) => !product.product_group_id);

          this.products.unshift({
            code: "Please select a product without group"
          });

          this.productCodeSelected = this.products[0].code;

          this.childrenProducts = data.filter((product) => product.product_group_id === this.productGroupForEdit.id);

          this.childrenProducts.sort((a, b) => a.position_in_group - b.position_in_group);

        } else {

          this.products = [];

          this.childrenProducts = [];
        }

        this.editing = true;
      })
      .catch((err) => {
        this.toastr.error(`Error getting products from group: ${JSON.stringify(err)}`);
      });
  }

  cancelGroupEditing() {
    this.editing = false;
    this.productGroupForEdit = {};
  }

  saveGroup(productGroup) {

    if (!productGroup.name) { this.toastr.warning(`Please enter the product group name`); return }
    // if (!productGroup.selection1_label) { this.toastr.warning(`Please enter a value for selection 1 label`); return }
    // if (!productGroup.selection2_label) { this.toastr.warning(`Please enter a value for selection 2 label`); return }
    // if (!productGroup.position) { this.toastr.warning(`Please enter a number in position`); return }
    if (productGroup.position && isNaN(productGroup.position)) { this.toastr.warning(`Value in position is not a number`); return }

    productGroup.position = parseInt(productGroup.position);

    this.GroupsService.updateProductGroup(productGroup.code, productGroup)
      .then(() => {
        this.toastr.success(`Product group has been updated`);
        this.getProductGroups();
      })
      .catch((err) => {
        this.toastr.error(`Error updating product group: ${JSON.stringify(err)}`);
      });
  }

  // saveChanges() {
  //   const config = {
  //     template: "app/components/modals/confirm.tpl.html",
  //     data: {
  //       title: "Editing Product Group",
  //       content: `Are you sure you want to change "${this.productGroupForEdit.name}"?`,
  //     },
  //   };

  //   this.ngDialog.openConfirm(config)
  //   .then(() =>
  //     this.GroupsService.updateProductGroup(
  //       this.productGroupForEdit.code,
  //       this.productGroupForEdit
  //     )
  //   )
  //   .then(() => {
  //     this.getProductGroups();
  //     this.cancelGroupEditing();
  //   })
  //   .catch((err) => {
  //     this.toastr.error(
  //       `Error updating product group: ${JSON.stringify(err)}`
  //     );
  //   });
  // }

  addProductToGroup(product_code) {
    if (product_code) {

      this.ProductsService.editProduct(product_code, {
        product_group_id: this.productGroupForEdit.id,
      })
        .then(() => {
          this.toastr.success(`Product has been added to the group`);
          this.getProducts(this.productGroupForEdit.service_code);
        })
        .catch((err) => {
          this.toastr.error(
            `Error adding product to group: ${JSON.stringify(err)}`
          );
        });
    }
  }

  saveProduct(product) {
    if (product) {

      if (!product.name) { this.toastr.warning(`Please enter the product name`); return }
      if (!this.BOD_2622 && !product.selection1) { this.toastr.warning(`Please enter a value for selection 1`); return }
      if (!product.selection2) { this.toastr.warning(`Please enter a value for selection 2`); return }
      if (!product.position_in_group) { this.toastr.warning(`Please enter a number in position in group`); return }
      if (isNaN(product.position_in_group)) { this.toastr.warning(`Please enter a number in position in group`); return }

      this.ProductsService.editProduct(product.code, {
        name: product.name,
        selection1: product.selection1,
        selection2: product.selection2,
        position_in_group: parseInt(product.position_in_group),
      })
        .then(() => {
          product.edit_mode = false;
          this.toastr.success(`Product has been updated`);
          this.getProducts(this.productGroupForEdit.service_code);
        })
        .catch((err) => {
          this.toastr.error(
            `Error updating product: ${JSON.stringify(err)}`
          );
        });
    }
  }

  removeProductFromGroup(product_code) {
    if (product_code) {

      this.ProductsService.editProduct(product_code, {
        product_group_id: null,
      })
        .then(() => {
          this.toastr.success(`Product has been removed from the group`);
          this.getProducts(this.productGroupForEdit.service_code);
        })
        .catch((err) => {
          this.toastr.error(
            `Error removing product from group: ${JSON.stringify(err)}`
          );
        });
    }
  }
}

GroupsController.$inject = ["GroupsService", "ProductsService", "toastr", "ngDialog", "Services"];
angular.module("pims").controller("GroupsController", GroupsController);
